export const LocationsActionTypes = {
    API_RESPONSE_SUCCESS: '@@locations/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@locations/API_RESPONSE_ERROR',
    READ_ALL_LOCATIONS_REQUEST: '@@locations/READ_ALL_LOCATIONS_REQUEST',
    CREATE_LOCATION_REQUEST: '@@locations/CREATE_LOCATION_REQUEST',
    UPDATE_LOCATION_REQUEST: '@@locations/UPDATE_LOCATION_REQUEST',
    DELETE_LOCATION_REQUEST: '@@locations/DELETE_LOCATION_REQUEST',
    RESET_STATE: '@@locations/RESET_STATE',
    RESET_ALL_ERRORS: '@@locations/RESET_ALL_ERRORS',
};
